import { useEffect } from 'react';
import { useRouter } from 'next/router';

export function usePageAnalytics() {
	const router = useRouter();

	useEffect(() => {
		navigator.sendBeacon(
			process.env.NEXT_PUBLIC_API_DOMAIN + '/analytics',
			JSON.stringify({
				eventType: 'page',
				origin: window.location.origin,
				title: document.title,
			}),
		);
	}, [router.pathname]);
}
